import src from "IMAGE";
export default { src, width: 1920, height: 296, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAG0lEQVR42mPIa6/4j44LOyv/9y/p+b/x8IL/AD3vFGAACwzbAAAAAElFTkSuQmCC"};
